import {
  type CheckoutErrorCode,
  checkoutErrorCodes,
} from '@/payment/services/checkout/types';
import type { SiteRuntimePricing } from '@/site-runtime/types';

export function isSiteRuntimeCheckoutErrorCode(
  value: unknown
): value is CheckoutErrorCode {
  return (
    typeof value === 'string' &&
    (checkoutErrorCodes as readonly string[]).includes(value)
  );
}

export function readSiteRuntimeCheckoutErrorCopy(
  pricing: Pick<SiteRuntimePricing, 'checkoutErrorCopy'>,
  code: CheckoutErrorCode
) {
  const message = pricing.checkoutErrorCopy[code]?.trim();
  if (!message) {
    throw new Error(`Pricing checkout error copy ${code} is not configured.`);
  }
  return message;
}
